<template>
  <div
    class="sitebuilder-element-container"
    element="SocialBarComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :id="id"
    :config-properties="JSON.stringify(internal_config)"
    v-on:click="focusElement($event)"
    @contextmenu.prevent="handler($event)"
    :style="style()"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
      :enable-native-drag="true"
    >
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>
      <sync-drag :target="this"/>
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-SocialBarComponent'></options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>
      <div v-bind:style="{'border-radius': radius,border : border}">
        <div
          class="embed-responsive embed-responsive-16by9 socialbar-parent"
          v-bind:style="getOrientation()"
        >
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkFacebook"
            :href="getUrl('Facebook')"
          >
            <img :src="getSrc('Facebook')" class="socialbar-icon"/>
          </a>
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkTwitter"
            :href="getUrl('Twitter')"
          >
            <img :src="getSrc('Twitter')" class="socialbar-icon"/>
          </a>
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkInstagram"
            :href="getUrl('Instagram')"
          >
            <img :src="getSrc('Instagram')" class="socialbar-icon"/>
          </a>
          <a
            class="socialbar-div"
            v-if="this.internal_config.checkLinkedin"
            :href="getUrl('Linkedin')"
          >
            <img :src="getSrc('Linkedin')" class="socialbar-icon"/>
          </a>
        </div>
      </div>
      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>
<script>
import Model from "./Model";
import Resources from "./Resources.vue";
import OptionsElementBar from "../OptionsElementBar";
import MixinComponents from "../../../../js/mixins/MixinComponents";

export default {
  name: "SocialBarComponent",
  mixins: [MixinComponents],
  components: {
    OptionsElementBar,
    Resources
  },
  props: ["config", "height_start", "device", "id", "preview"],
  data() {
    return Model.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },
  computed: {},
  methods: {
    animation() {
      return true;
    },
    rebuild() {
      let vm = this;
      let config = this.internal_config;
      this.internal_config = {};
      this.$nextTick(() => {
        vm.internal_config = config;
        this.$root.$emit("rSidebarEdition", vm);
      });
    },
    getUrl(type) {
      if (type == "Facebook") {
        return this.internal_config.sbFacebook;
      } else if (type == "Twitter") {
        return this.internal_config.sbTwitter;
      } else if (type == "Instagram") {
        return this.internal_config.sbInstagram;
      } else if (type == "Linkedin") {
        return this.internal_config.sbLinkedin;
      }
    },
    getOrientation() {
      let {orientation, spaceBetween} = this.internal_config;
      orientation = orientation ? "block" : "inline-flex";
      return `display: ${orientation}; gap: ${spaceBetween}px`;
    },
    getSrc(type) {
      return this.internal_config[`image${type}`]
        ? this.internal_config[`image${type}`]
        : "vazio";
    },

    onResize: function (x, y, width, height) {
      this.internal_config.width = width + "px";
      this.internal_config.height = height + "px";

      this.$refs.resourcesData.setValuesData(this);
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    //change order on html
    changeOrderPanel(elem, idx) {
      let id = elem.$el.id,
        sibling =
          idx === 1
            ? document.getElementById(id).nextSibling
            : document.getElementById(id).previousSibling;

      if (sibling === null) {
        return true;
      }

      let vm = this;
      this.$root.$emit("changeOrderElementsInside", vm.id, id, sibling.id, idx);
    },
    style() {
      let {
        left,
        zIndex,
        paddingTop,
        paddingLeft,
        paddingRight,
        paddingBottom,
        top
      } = this.internal_config;

      let style = `
                     left:  ${left};
                     z-index: ${zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${paddingTop};
                     padding-left: ${paddingLeft};
                     padding-right: ${paddingRight};
                     padding-bottom: ${paddingBottom};
					 top: ${top}`;

      return style;
    },
  },
  created() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== "undefined") {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    this.$refs.resourcesData.setValuesData(this);
    if (this.$props.preview) {
      this.$root.$emit("applyAnimation", this, "sitebuilder-element-container");
    }
    let objIds = [];
    $("[id]").each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$forceUpdate();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.socialbar-parent:before {
  content: none;
}

.socialbar-div {
  height: auto;
  width: 100%;
}

.socialbar-icon {
  height: auto;
  width: 100%;
}

.vdr {
  height: auto !important;
}

.preview-img {
  width: 100%;
  height: auto;
}

[data-device="mobile"] .socialbar-parent {
  display: inline-flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/SocialBar/SocialBar.vue